import { AxiosRequestConfig } from 'axios';
import { apiClient } from './apiClient';

// Export service object with utility methods
export const apiService = {
  // Base HTTP methods
  get: (url: string, config?: AxiosRequestConfig) => apiClient.get(url, config),
  post: (url: string, data?: unknown, config?: AxiosRequestConfig) =>
    apiClient.post(url, data, config),
  put: (url: string, data?: unknown, config?: AxiosRequestConfig) =>
    apiClient.put(url, data, config),
  delete: (url: string, config?: AxiosRequestConfig) => apiClient.delete(url, config),
  patch: (url: string, data?: unknown, config?: AxiosRequestConfig) =>
    apiClient.patch(url, data, config),
};

export { apiClient as default } from './apiClient';

export async function getNangoCredentials(integrationId: string): Promise<any> {
  const res = await apiClient.get(`/api/v1/nango/credentials?integrationId=${integrationId}`);
  return res.data;
}

export async function setConnectionMetadata(
  integrationId: string,
  metadata: Record<string, any>,
): Promise<void> {
  await apiClient.post('/api/v1/nango/set-connection-metadata', { integrationId, metadata });
}
